import type { SchedulingWindowPeriod } from '../endpoints/fetchFirstOccurrence';

const periodKey = (period: SchedulingWindowPeriod): string => `${period.open}\0${period.close}`;

/**
 * Union two scheduling-window period lists, dropping exact open/close duplicates
 * and returning periods sorted chronologically by open time.
 */
export function mergeAvailablePeriods(
  existing: ReadonlyArray<SchedulingWindowPeriod>,
  incoming: ReadonlyArray<SchedulingWindowPeriod>
): SchedulingWindowPeriod[] {
  if (incoming.length === 0) {
    return [...existing];
  }

  const byKey = new Map<string, SchedulingWindowPeriod>();
  for (const period of existing) {
    byKey.set(periodKey(period), period);
  }
  for (const period of incoming) {
    byKey.set(periodKey(period), period);
  }

  return [...byKey.values()].sort((a, b) => {
    const openDiff = a.open.localeCompare(b.open);
    return openDiff !== 0 ? openDiff : a.close.localeCompare(b.close);
  });
}
